import { render, staticRenderFns } from "./SysUpdateLogList.vue?vue&type=template&id=a47c82a4&scoped=true"
import script from "./SysUpdateLogList.vue?vue&type=script&lang=js"
export * from "./SysUpdateLogList.vue?vue&type=script&lang=js"
import style0 from "./SysUpdateLogList.vue?vue&type=style&index=0&id=a47c82a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c82a4",
  null
  
)

export default component.exports